export default function AboutStory() {
  return (
    <section className="py-20 bg-neutral-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="w-full h-[420px] rounded-lg overflow-hidden">
            <img
              src="https://public.readdy.ai/ai/img_res/201a54ee74a96b6b8f1345d8aefbb870.jpg"
              alt="Our story — Beast Mode Movers"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div>
            <p className="text-[#70DC28] font-bebas tracking-[0.3em] text-sm mb-3">OUR STORY</p>
            <h2 className="font-bebas text-5xl lg:text-6xl text-[#0f0f0f] leading-tight mb-6">
              BUILT IN BREVARD,<br />
              <span className="text-[#70DC28]">BUILT FOR FLORIDA</span>
            </h2>
            <div className="space-y-4">
              <p className="text-neutral-600 text-sm leading-relaxed">
                Beast Mode Movers was founded right here in Brevard County by local residents who were tired of hearing the same moving horror stories — late crews, broken furniture, surprise fees. We knew we could do better.
              </p>
              <p className="text-neutral-600 text-sm leading-relaxed">
                We started with a single truck and a simple commitment: show up on time, handle everything with care, and charge exactly what we quote. That approach earned us a five-star reputation that now spans hundreds of completed moves across Melbourne, Titusville, Rockledge, and beyond.
              </p>
              <p className="text-neutral-600 text-sm leading-relaxed">
                Today, Beast Mode Movers is one of Brevard County&apos;s most trusted moving companies. We&apos;ve expanded our fleet and crew, added specialty services including piano moving and hot tub relocation, and still maintain the same personal standards we started with.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
